import {type ColonistGiftMembershipProduct} from '../../../../../shared/store/ColonistGiftMembershipProduct.ts'
import {UIStoreMembershipProductView} from '../UIStoreMembershipProductView.ts'
import {type UIStoreState} from '../UIStoreState.ts'
import {createDivIn, createHeaderIn, createParagraphIn, setElementInnerHTML} from '../../ui_utils/DomUtils.ts'
import {ClientUserState} from '../../ClientUserState.ts'
import {type TranslationObject} from '@colonist/i18n'
import {type LocalizedPricingProductsPayload} from '@colonist/mobile'
import {ColonistMembershipProduct} from '../../../../../shared/store/ColonistMembershipProduct.ts'

export class UIStoreGiftMembershipProductView extends UIStoreMembershipProductView {
    private readonly localizedStoreProductData: LocalizedPricingProductsPayload[] = []

    constructor(parentDiv: HTMLDivElement, storeState: UIStoreState, product: ColonistGiftMembershipProduct, localizedStoreProductData: LocalizedPricingProductsPayload[]) {
        super(parentDiv, storeState, product)
        this.localizedStoreProductData = localizedStoreProductData
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.select'})
        this.subscribeButtonText.style.marginBottom = '0'
        this.setPrice(product.getDefaultPrice())
        this.subscribeButton.classList.add('button-select')
        if(this.isAnnualGiftMembership()) this.showStrikeThroughPrice()
    }

    select() {
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.selected'})
        this.productDiv.classList.add('selected')
        this.subscribeButton.classList.add('selected')
    }

    deselect() {
        setElementInnerHTML(this.subscribeButtonText, {key: 'strings:storePage.sections.giftOverlay.tierSelection.select'})
        this.productDiv.classList.remove('selected')
        this.subscribeButton.classList.remove('selected')
    }

    setPrice(price: string) {
        const localizedProductData = this.localizedStoreProductData.find((data) => data.productId == this.membershipProduct.mobileIAPSKUId)
        const localizedPrice = localizedProductData ? `${localizedProductData.currency}${localizedProductData.price}` : undefined
        setElementInnerHTML(this.priceDiv, {key: 'strings:colonistCommon.utils.emptyString'})
        this.membershipPrice = createHeaderIn(this.priceDiv, {key: 'strings:colonistCommon.utils.emptyString'}, '', '', 'H1')
        setElementInnerHTML(this.membershipPrice, {key: 'strings:colonistCommon.utils.#buffer', options: {value: localizedPrice ?? `$${price}`}})
        this.disclaimerText.replaceChildren()
    }

    isAnnualGiftMembership(): boolean {
        return this.membershipProduct.discount != 0
    }

    protected override addBestValueHint() {
        if(!this.membershipProduct.bestValue) return

        const shouldShowMostPopularText = ClientUserState.abTests.GIFTING_CHANGE_BEST_VALUE_HINT == 'SHOW_MOST_POPULAR'
        const hintText: TranslationObject = shouldShowMostPopularText ? {key: 'strings:storePage.mostPopular'} : {key: 'strings:storePage.bestValue'}
        this.productDiv.classList.add('store_page_membership_best_value_border')
        const badge = createDivIn(this.headerDiv, 'badge-white badge-lg')
        createParagraphIn(badge, hintText, '')
    }

    protected override showStrikeThroughPrice() {
        const monthlyPrice = ColonistMembershipProduct.getMonthlyPriceOfAnnualMembership(this.getColonistMembershipType())
        if(monthlyPrice == undefined) return

        const yearlyPrice = parseFloat(monthlyPrice) * 12
        const strikethroughPrice = createParagraphIn(this.priceDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: `<s>$${yearlyPrice}</s>`}}, 'strikethrough-price', '')
        this.priceDiv.insertBefore(strikethroughPrice, this.priceDiv.firstChild)
    }
}
